export default __webpack_public_path__ + "static/media/lightningstrikes.17a59e61.png";